export const theme = {
    token: {
        "colorPrimary": "#722ed1",
        "colorInfo": "#722ed1"
    },
};
